import React, { useState } from "react";
import Swal from "sweetalert2";

const emptyObjectif = {
    titre: "",
    description: "",
    indicateur: "",
    performanceCible: "",
    poids: "",
    typeObjectif: "QUANTITATIF",
    priorite: "",
    typeIndicateur: "",
    surperformance: "",
    tolerance: "",
    dateFin: "",
};

function Field({ label, children, required }) {
    return (
        <div className="on-field">
            <label className="on-field__label">
                {label}
                {required && <span className="on-field__required"> *</span>}
            </label>
            {children}
        </div>
    );
}

export default function ObjectifNCreationForm({ title = "Nouvel objectif", submitLabel = "Ajouter l'objectif", onSubmit, onCancel }) {
    const [form, setForm] = useState(emptyObjectif);
    const updateForm = (patch) => setForm((current) => ({ ...current, ...patch }));

    const submit = (event) => {
        event.preventDefault();
        if (form.poids === "" || form.poids == null) {
            Swal.fire({
                icon: "warning",
                title: "Champ obligatoire",
                text: "Poids nul, veuillez le saisir.",
                confirmButtonText: "Compris",
            });
            return;
        }
        onSubmit(form);
        setForm(emptyObjectif);
    };

    return (
        <form className="on-form" onSubmit={submit}>
            <div className="on-form__section-label">{title}</div>
            <div className="on-form__row on-form__row--3">
                <Field label="Titre" required>
                    <input className="on-input" required value={form.titre} onChange={(event) => updateForm({ titre: event.target.value })} placeholder="Intitulé de l'objectif" />
                </Field>
                <Field label="Priorité">
                    <input className="on-input" type="number" min="1" value={form.priorite} onChange={(event) => updateForm({ priorite: event.target.value })} placeholder="1" />
                </Field>
                <Field label="Date d'échéance">
                    <input className="on-input" type="date" value={form.dateFin} onChange={(event) => updateForm({ dateFin: event.target.value })} />
                </Field>
            </div>

            <div className="on-form__section-label">Indicateurs & mesure</div>
            <div className="on-form__row on-form__row--4">
                <Field label="Indicateur">
                    <input className="on-input" value={form.indicateur} onChange={(event) => updateForm({ indicateur: event.target.value })} placeholder="KPI ou métrique" />
                </Field>
                <Field label="Type d'indicateur">
                    <select className="on-select" value={form.typeIndicateur} onChange={(event) => updateForm({ typeIndicateur: event.target.value })}>
                        <option value="">Sélectionner</option>
                        <option value="Pourcentage">Pourcentage</option>
                        <option value="Nombre">Nombre</option>
                        <option value="Taux">Taux</option>
                    </select>
                </Field>
                <Field label="Performance cible">
                    <input className="on-input" type="number" step="0.01" value={form.performanceCible} onChange={(event) => updateForm({ performanceCible: event.target.value })} placeholder="0.00" />
                </Field>
                <Field label="Poids (%)">
                    <input className="on-input" type="number" value={form.poids} onChange={(event) => updateForm({ poids: event.target.value })} placeholder="0" />
                </Field>
            </div>

            <div className="on-form__row on-form__row--2">
                <Field label="Surperformance">
                    <input className="on-input" type="number" step="0.01" value={form.surperformance} onChange={(event) => updateForm({ surperformance: event.target.value })} placeholder="0.00" />
                </Field>
                <Field label="Tolérance">
                    <input className="on-input" type="number" step="0.01" value={form.tolerance} onChange={(event) => updateForm({ tolerance: event.target.value })} placeholder="0.00" />
                </Field>
            </div>

            <div className="on-form__section-label">Type d'objectif</div>
            <div className="on-radio-group">
                <label className={`on-radio-option ${form.typeObjectif === "QUANTITATIF" ? "on-radio-option--active" : ""}`}>
                    <input type="radio" name="typeObjectif" value="QUANTITATIF" checked={form.typeObjectif === "QUANTITATIF"} onChange={(event) => updateForm({ typeObjectif: event.target.value })} />
                    <span className="on-radio-option__dot" />
                    <span>Quantitatif</span>
                </label>
                <label className={`on-radio-option ${form.typeObjectif === "QUALITATIF" ? "on-radio-option--active" : ""}`}>
                    <input type="radio" name="typeObjectif" value="QUALITATIF" checked={form.typeObjectif === "QUALITATIF"} onChange={(event) => updateForm({ typeObjectif: event.target.value })} />
                    <span className="on-radio-option__dot" />
                    <span>Qualitatif</span>
                </label>
            </div>

            <Field label="Description">
                <textarea className="on-textarea" rows={3} value={form.description} onChange={(event) => updateForm({ description: event.target.value })} placeholder="Décrivez l'objectif en détail..." />
            </Field>

            <div className="on-form__footer">
                {onCancel && (
                    <button className="on-btn on-btn--outline" type="button" onClick={onCancel}>
                        Annuler
                    </button>
                )}
                <button className="on-btn on-btn--primary" type="submit">
                    <span>+</span> {submitLabel}
                </button>
            </div>
        </form>
    );
}
